import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';
import _ from 'lodash';

const useGetChannelReport = (params) => {
    const isParams = !_.isEmpty(params);
    const searchparam = isParams ? `?searchparam=name.${params}` : '';
    return useQuery({
        queryKey: ['customer-channel-report', searchparam],
        queryFn: async () => {
            const { data } = await authAxios.get(`api/v1/master-data/channel-report${searchparam}`);
            return data?.listChannelReport;
        },
        enabled: !!searchparam,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};

export default useGetChannelReport;
